import { useState } from 'react';
import {
    PageType,
    SegmentContextType,
} from 'flow/components/call-history-v2/types';
import { useCallRecordDetail } from 'flow/hooks/api/useCallRecordDetail';
import { useCallRecordWithCtiContact } from 'flow/hooks/useCallRecordWithCtiContact';
import {
    CallRecordDetailHeaderSkeleton,
    CallRecordDetailContentSkeleton,
} from 'flow/components/pbx/v2/detail-page/CallRecordDetailSkeleton';
import { CallRecordKey } from 'flow/types/EntityKeys';
import BaseModal, { modalSizes } from 'flow/components/ui-components/BaseModal';
import CallRecordDetailContent from 'flow/components/pbx/v2/detail-page/CallRecordDetailContent';
import HeaderCallRecordDetail from 'flow/components/pbx/v2/detail-page/HeaderCallRecordDetail';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    callRecordKey?: CallRecordKey;
    pageType?: PageType;
    segmentContext?: SegmentContextType;
}

const CallRecordDetailModalV2 = ({
    callRecordKey: initialCallRecordKey,
    pageType,
    segmentContext,
}: Props) => {
    const { i18next } = useAppContext();
    const [currentCallRecordKey, setCurrentCallRecordKey] =
        useState(initialCallRecordKey);

    const {
        callRecord: rawCallRecord,
        ticketKey,
        ticketScopeIsResolved,
        extendedTranscription,
    } = useCallRecordDetail(currentCallRecordKey, 'modal');
    const callRecord = useCallRecordWithCtiContact(rawCallRecord);

    return (
        <BaseModal
            open={true}
            ariaLabel={i18next.t('call.history.title')}
            disableActions={true}
            disablePadding={true}
            modalSize={modalSizes.MEDIUM}
            className="max-h-[90dvh] min-h-[90dvh] dark:bg-gray-100!"
        >
            {!callRecord ? (
                <div>
                    <div className="ps-6 pe-4">
                        <CallRecordDetailHeaderSkeleton />
                    </div>
                    <CallRecordDetailContentSkeleton
                        tabsHidden={['RELATED']}
                        contentClassName="ps-6 pe-4"
                    />
                </div>
            ) : (
                <div className="flex h-[calc(90dvh-60px)] flex-col">
                    <HeaderCallRecordDetail
                        callRecordKey={currentCallRecordKey}
                        ticketKey={ticketKey}
                        ticketScopeIsResolved={ticketScopeIsResolved}
                        subject={extendedTranscription?.subject}
                        segmentContext={segmentContext}
                        pageTypeDemandsBackButton={false}
                        className="ps-6 pe-4"
                    />
                    <div className="flex min-h-0 flex-1 flex-col pb-4">
                        <CallRecordDetailContent
                            key={currentCallRecordKey}
                            callRecordKey={currentCallRecordKey}
                            ticketKey={ticketKey}
                            ticketAccessDenied={undefined}
                            extendedTranscription={extendedTranscription}
                            pageType={pageType}
                            segmentContext={segmentContext}
                            onNavigateToCallRecord={setCurrentCallRecordKey}
                            contentClassName="ps-6 pe-4"
                            inputClassName="px-6"
                            dateLabelBgClassName="dark:bg-gray-100"
                            tabsHidden={['RELATED']}
                        />
                    </div>
                </div>
            )}
        </BaseModal>
    );
};

export default CallRecordDetailModalV2;
